import React, { useEffect, useState } from "react";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import httpService from "../../../../services/http/stores/outlet.service";
import usePagination, {
  createInitialPagination,
} from "../../../../custom-hooks/usePagination";
import UnlimitTable from "../../../../components/ui-kit/unlimit-table";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { DatePicker, Modal } from "antd";
import notificationService from "../../../../services/toaster.service";
import useRoleAndPerm from "../../../../utils/permissionFunction";
const OutletDetailsLogs = ({ type, id }) => {
  const [loading, setLoading] = useState(false);
  const [checkoutLoading, setCheckoutLoading] = useState(false);
  const [designations, setDesignations] = useState([]);
  const [nameFilter, setNameFilter] = useState("");
  const [idFilter, setIdFilter] = useState("");
  const [selectedVendor, setSelectedVendor] = useState([]);
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [checkoutModalVisible, setCheckoutModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [checkoutReason, setCheckoutReason] = useState("");
  const [createOrder, setCreateOrder] = useState(true);
  const initialPagination = createInitialPagination(t);
  const { paginationParams, updatePaginationParams } =
    usePagination(initialPagination);

  const { hasPermission } = useRoleAndPerm();
  const getOutletsList = async (
    pagination = paginationParams.pagination,
    filters,
    sorter = {}
  ) => {
    const data = {
      page: pagination?.current,
      per_page: pagination?.pageSize,
      ...filters,
      ...sorter,
    };

    setLoading(true);

    await httpService
      .outletLogsList(data)
      .then((response) => {
        if (response.status == 200) {
          setDesignations(response.data.data?.data);
        }

        updatePaginationParams({
          pagination: {
            ...paginationParams.pagination,
            current: response.data.data.current_page,
            total: response.data.data.total,
            pageSize: response.data.data.per_page,
          },
        });
      })
      .catch((error) => {
        console.error("Error:", error);
        updatePaginationParams({
          pagination: {
            ...paginationParams.pagination,
          },
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCheckout = async (record) => {
    setSelectedRecord(record);
    setCheckoutModalVisible(true);
    setCheckoutReason("");
    setCreateOrder(true);
  };

  const handleCheckoutConfirm = async () => {
    if (!checkoutReason.trim()) {
      notificationService.errorMessage("Please provide a reason for checkout.");
      return;
    } else if (checkoutReason.trim().length < 3) {
      notificationService.errorMessage(
        "Reason should be at least 3 characters long."
      );
      return;
    } else if (checkoutReason.trim().length > 200) {
      notificationService.errorMessage(
        "Reason should not exceed 100 characters."
      );
      return;
    }

    setCheckoutLoading(true);

    try {
      const response = await httpService.checkoutUser(
        selectedRecord.id,
        checkoutReason.trim(),
        createOrder // Pass the checkbox value to the function
      );

      if (response.status === 200) {
        console.log("Checkout successful");

        setCheckoutModalVisible(false);
        setSelectedRecord(null);
        setCheckoutReason("");
        setCreateOrder(true); // Reset checkbox after successful checkout

        await getOutletsList();
      }
    } catch (error) {
      console.error("Checkout error:", error);
    } finally {
      setCheckoutLoading(false);
    }
  };

  const handleCheckoutCancel = () => {
    setCheckoutModalVisible(false);
    setSelectedRecord(null);
    setCheckoutReason("");
    setCreateOrder(true);
  };

  const handleTableChange = async (pagination, filters, sorter) => {
    filters = {
      name: nameFilter,
      id: idFilter,
      start_date: startDate
        ? moment(startDate).format("YYYY-MM-DD HH:MM:SS")
        : null,
      end_date: endDate ? moment(endDate).format("YYYY-MM-DD HH:MM:SS") : null,
    };

    if (type == "SHOPPER" || type == "EMP") {
      filters.resourceable_id = id;
    } else if (type == "OUTLET") {
      filters.outlet_id = id;
    }

    const nonNullFilters = Object.fromEntries(
      Object.entries(filters).filter(([, value]) => !!value)
    );

    if (sorter && sorter.field) {
      sorter = {
        sort_by: sorter.field,
        sort_direction: sorter.order == "ascend" ? "ASC" : "DESC",
      };
    }

    if (!pagination) {
      pagination = initialPagination;
    }

    await updatePaginationParams({
      pagination,
      filters,
      sorter,
    });

    await getOutletsList(pagination, nonNullFilters, sorter);
  };

  useEffect(() => {
    handleTableChange();
  }, []);

  const columns = [
    {
      title: t("tableColumnName.srNo"),
      dataIndex: "index",
      align: "center",
      render: (value, item, index) =>
        (paginationParams.pagination?.current - 1) *
          paginationParams.pagination?.pageSize +
        (index + 1),
    },
    {
      title: t("inputField.label.userName"),
      dataIndex: "entry_time",
      render: (text, record) => record.resourceable?.name,
    },
    {
      title: t("tableColumnName.shopeEnterTime"),
      dataIndex: "entry_time",
      // sorter: true,
      render: (text, record) => {
        return text ? moment(text).format("DD MMM YYYY - HH:mm:ss") : "";
      },
    },
    {
      title: t("tableColumnName.shopExitTime"),
      dataIndex: "exit_time",
      // sorter: true,
      render: (text, record) => {
        return text ? moment(text).format("DD MMM YYYY - HH:mm:ss") : "";
      },
    },
    {
      title: t("logs.type"),
      dataIndex: "is_active",
      render: (text, record) => {
        if (record.resourceable?.type == "employee") {
          return (
            <span className="badge badge-linesuccess">
              <a>{t("employee.employee")}</a>
            </span>
          );
        } else {
          return (
            <span className="badge badge-linedanger">
              <a>{t("shopper.shopper")}</a>
            </span>
          );
        }
      },
    },
    {
      title: "Checkout Reason",
      dataIndex: "exit_reason",
      width: "250px",
      ellipsis: true,
      render: (text, record) => {
        return text || "-";
      },
    },
    {
      title: t("tableColumnName.actions"),
      dataIndex: "actions",
      align: "center",
      hidden: !hasPermission(["shop-logs-edit"]),
      render: (text, record) => {
        if (!record.exit_time && record.resourceable?.type !== "employee") {
          return (
            <button
              className="btn btn-primary btn-sm"
              onClick={() => handleCheckout(record)}
              disabled={checkoutLoading}
            >
              {"Checkout"}
            </button>
          );
        }
        return "-";
      },
    },
  ];

  return (
    <div>
      {/* /product list */}
      <div className="table-top row">
        <div className="col-lg-5 col-sm-4 col-12">
          <DatePicker
            style={{ width: "100%", height: "40px" }}
            showTime
            onChange={(_, dateStr) => setStartDate(dateStr)}
            placeholder="Start Date"
          />
        </div>
        <div className="col-lg-5 col-sm-4 col-12">
          <DatePicker
            style={{ width: "100%", height: "40px" }}
            showTime
            onChange={(_, dateStr) => setEndDate(dateStr)}
            placeholder="End Date"
          />
        </div>
        <div className="col-lg-2 col-sm-4 col-12 ms-auto">
          <div className="input-blocks mb-0">
            <button
              className="btn btn-filters col-auto ms-auto px-2"
              style={{ width: "fit-content" }}
              onClick={handleTableChange}
            >
              <i data-feather="search" className="feather-search m-0" />
            </button>
          </div>
        </div>
      </div>

      <div className="table-responsive">
        <UnlimitTable
          pagination={paginationParams.pagination}
          columns={columns}
          dataSource={designations}
          rowKey={(record) => record.id}
          loading={loading}
          onChange={handleTableChange}
        />
      </div>

      {/* Checkout Modal */}
      <Modal
        title={"Checkout Confirmation"}
        open={checkoutModalVisible}
        onOk={handleCheckoutConfirm}
        onCancel={handleCheckoutCancel}
        confirmLoading={checkoutLoading}
        okText={"Checkout"}
        cancelText={"Cancel"}
        destroyOnClose={true}
      >
        <div className="mb-3">
          <p className="mb-2">
            <strong>{"User"}:</strong> {selectedRecord?.resourceable?.name}
          </p>
          <p className="mb-3">
            <strong>{"Entry Time"}:</strong>{" "}
            {selectedRecord?.entry_time
              ? moment(selectedRecord.entry_time).format(
                  "DD MMM YYYY - HH:mm:ss"
                )
              : "-"}
          </p>
        </div>

        <div className="form-group mb-3">
          <label className="form-label">
            {"Reason for Checkout"} <span className="text-danger">*</span>
          </label>
          <textarea
            className="form-control"
            rows={4}
            value={checkoutReason}
            onChange={(e) => setCheckoutReason(e.target.value)}
            placeholder={"Please enter the reason for checkout..."}
          />
        </div>

        {/* Create Order Checkbox */}
        <div className="form-group">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="createOrderCheck"
              checked={createOrder}
              onChange={(e) => setCreateOrder(e.target.checked)}
            />
            <label className="form-check-label" htmlFor="createOrderCheck">
              Create Order
            </label>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default OutletDetailsLogs;
